import ReferioHomeContainer from "@/containers/ReferioHome/ReferioHomeContainer";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";

export default function ReferioHome() {
  return <ReferioHomeContainer funnelKey={landingFunnelKey.GROUP.rfr_mixed} />;
}
